import { useMutation, useQueryClient } from "@tanstack/react-query";

import { resetRetryBudget } from "./api";
import type { RetryBudgetResponse } from "./api";

// DELETE бюджета организации (откат к заводскому). Как и сохранение,
// затрагивает эффективный бюджет репозиториев.
export function useResetRetryBudget(): ReturnType<
  typeof useMutation<RetryBudgetResponse, Error, void>
> {
  const queryClient = useQueryClient();
  return useMutation<RetryBudgetResponse, Error, void>({
    mutationFn: () => resetRetryBudget(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["retryBudget"] });
      void queryClient.invalidateQueries({
        queryKey: ["repositorySettings"],
      });
    },
  });
}
